import { MaintenanceObjectKind } from '../models/maintenance-job.model';

export function isCorrectiveActionKind(
  kind: MaintenanceObjectKind | string | number | null | undefined
): boolean {
  if (kind === null || kind === undefined || kind === '') {
    return false;
  }

  return (
    kind === MaintenanceObjectKind.CorrectiveAction ||
    kind === 'CorrectiveAction' ||
    kind === '1' ||
    kind === 1
  );
}
